import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import FAQBridged from '../components/FAQ/faq';
import { Layout } from '../components/layout';
import Seo from '../components/seo';

const FAQPage = ({ location, pageContext }) => {
  const { t } = useTranslation();
  return (
    <Layout>
      <Seo title={t('trans.faq')} />
      <FAQBridged location={location} lang={pageContext.language} />
    </Layout>
  );
};

export default FAQPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
